export const FETCH_PROCEDURES_LIST_REQUEST = "FETCH_PROCEDURES_LIST_REQUEST";
export const FETCH_PROCEDURES_LIST_SUCCESS = "FETCH_PROCEDURES_LIST_SUCCESS";
export const FETCH_PROCEDURES_LIST_FAILURE = "FETCH_PROCEDURES_LIST_FAILURE";
